<div>   
<survey [model]="model"></survey> 
</div>
<div class="containerClose">
    <button  class="button-pattern" (click)="goBack();" >Close</button>   
</div>

<!--<div id="surveyContainer"></div>-->
<!--<pre id="previewOutput"></pre>-->